import { OrderByPropertyOfCatalogOrderByEnumRequestDto } from '@core/services/apiclient';
import { createAction, props } from '@ngrx/store';
import { TableFilterResult } from '@shared/models/table-filter.model';

export const setCatalogListFilters = createAction(
  '[Catalog] set Catalog List Filters ',
  props<{ filters: TableFilterResult[] }>(),
);

export const setEventsListOrderBy = createAction(
  '[Catalog] Set Events List OrderBy',
  props<{ orderBy: OrderByPropertyOfCatalogOrderByEnumRequestDto | null }>(),
);

export const resetCatalogListState = createAction(
  '[Catalog] Reset Events List State'
);

export const setPassedToggle = createAction('[Catalog] Set Passed Toogle', props<{ pastEvents: boolean }>());
